import { createLinkCell } from "../../Logs/constants/logConstants";

/** Per-company progress columns for the selected batch. */
export const PIPELINE_RUN_COLUMNS = [
  {
    field: "logs",
    headerName: "Logs",
    width: 70,
    sortable: false,
    renderCell: (params) =>
      params.row.log_stream_name ? createLinkCell(params.row.log_stream_name) : null,
  },
  { field: "company_name", headerName: "Company", width: 160 },
  { field: "status", headerName: "Status", width: 140 },
  { field: "task_state", headerName: "Task State", width: 120 },
  { field: "error_count", headerName: "Error Count", width: 110 },
  { field: "retry_count", headerName: "Retry Count", width: 110 },
  { field: "last_updated", headerName: "Last Updated", width: 200 },
];

/** Previous-runs table: one row per classification-pipeline celery batch. */
export const PIPELINE_HISTORY_COLUMNS = [
  { field: "created_at", headerName: "Started", width: 200 },
  { field: "status", headerName: "Status", width: 120 },
  { field: "company_count", headerName: "Companies", width: 110 },
  { field: "companies", headerName: "Company names", flex: 1, minWidth: 200 },
];

const COMPANY_PREVIEW_LIMIT = 3;

/** Shape GET /get-pipeline-runs rows for the previous-runs DataGrid. */
export function mapPipelineHistoryRuns(rawRuns) {
  return rawRuns.map((run) => {
    const companies = run.companies ?? [];
    const preview = companies.slice(0, COMPANY_PREVIEW_LIMIT).join(", ");
    const extraCount = companies.length - COMPANY_PREVIEW_LIMIT;
    const extra = extraCount > 0 ? ` +${extraCount}` : "";
    return {
      id: run.task_id,
      task_id: run.task_id,
      created_at: run.created_at ?? "",
      status: run.status ?? "",
      company_count: run.company_count ?? companies.length,
      companies: `${preview}${extra}`,
    };
  });
}

// Mirrors TERMINAL_COMPANY_STATUSES in server/modules/classification_pipeline/pipeline_graph.py
export const TERMINAL_STATUSES = ["done", "needs_review", "timed_out", "error", "cancelled"];

/** Every submitted company has a Mongo row and a finished status — safe to start the report poll. */
export function isReadyForReport(rows, expectedCount) {
  if (rows.length !== expectedCount) {
    return false;
  }
  return rows.every((row) => TERMINAL_STATUSES.includes(row.status));
}

/** Alert text for each terminal poll outcome (see applyCeleryPollOutcomeToAlert). */
export const POLL_ALERT_COPY = {
  success: { severity: "success", headline: "Classification pipeline completed." },
  failed: { severity: "error", headline: "Classification pipeline failed." },
  cancelled: { severity: "warning", headline: "Classification pipeline cancelled." },
  timeout: {
    severity: "warning",
    message:
      "Report generation is taking longer than expected. Check task logs or try again later.",
  },
  fallback: { severity: "error", message: "Could not verify classification pipeline status." },
};
